














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppNavigation extends Vue {
  public data() {
    return {
      appTitle: 'WHAT THE FAKE',
      drawer: false,
      items: [{ title: 'Sign In' }, { title: 'Join' }],
    };
  }
  public isAuthenticated() {
    return this.$store.getters.isAuthenticated;
  }
  public logout() {
    this.$store.dispatch('userSignOut');
  }
  public isAdmin() {
    return this.$store.getters.isAdmin;
  }
}
